import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { FC } from 'react';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { media } from 'src/styles/designs';
import { dirRTL, fromTheme, redTheme } from 'src/styles/theme';
import { Theme } from 'vendor/mods/styled-components';

const Header = styled.h1`
  font-size: 24px;
  font-weight: 300;
  line-height: 29px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.palette.accent};
  max-width: 280px;

  ${media.w.greaterThanOrEqual.desktop} {
    max-width: 820px;
    font-size: 50px;
    line-height: 70px;
  }
`;

const Container = styled.div`
  background-color: ${fromTheme((theme) => theme.palette.background)};
  position: relative;
  height: 285px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.w.greaterThanOrEqual.desktop} {
    height: 588px;
  }
`;

const Needle = styled.div`
  background-color: ${fromTheme((theme) => theme.palette.contrastToBackground)};
  position: relative;
  clip-path: polygon(0 0, 40% 0, 100% 100%, 97% 100%);
  width: 45px;
  height: 100%;
  top: 0;
  right: 15px;
  z-index: 0;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 111px;
    height: 100%;
    right: 57px;
    bottom: 0;
  }
  ${dirRTL} {
    clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);
    left: 15px;
    right: auto;
    ${media.w.greaterThanOrEqual.desktop} {
      left: 57px;
    }
  }
`;

interface AboutUsHeaderProps {
  msgId: string;
}

export const AboutUsNeedleHeading: FC<AboutUsHeaderProps> = ({ msgId }) => {
  const { _ } = useTranslate();

  return (
    <Theme theme={redTheme}>
      <Container>
        <Needle />
        <Header>
          <Markdown>{_(msgId)}</Markdown>
        </Header>
      </Container>
    </Theme>
  );
};
